import SeoLandingPage from "../components/SeoLandingPage";

const page = {
  path: "/ai-hiring-platform",
  breadcrumbName: "AI Hiring Platform",
  serviceType: "AI Hiring Platform",
  eyebrow: "AI Hiring Platform",
  title: "AI Hiring Platform | Reduce Time-to-Hire with Aptofy",
  description:
    "Aptofy is an AI hiring platform that automates interviews, scores candidates in real time, and delivers bias-free hiring decisions with proctored assessments.",
  keywords:
    "AI hiring platform, AI hiring software, automated hiring platform, AI recruitment platform, Aptofy AI hiring",
  h1: "AI Hiring Platform to Reduce Time-to-Hire by up to 70%",
  intro:
    "Aptofy’s patented AI hiring platform interviews, evaluates, and shortlists candidates automatically — so your team hires faster without sacrificing quality or fairness.",
  sections: [
    {
      heading: "What Is an AI Hiring Platform?",
      paragraphs: [
        "An AI hiring platform uses artificial intelligence to automate parts of recruitment — from screening and interviewing to scoring and shortlisting. Instead of relying only on manual scheduling and subjective evaluations, teams get consistent, data-backed candidate insights.",
        "Aptofy combines AI agent interviewing, real-time scoring, and proctored assessments in one platform built for modern talent acquisition.",
      ],
    },
    {
      heading: "How Aptofy Works",
      paragraphs: [
        "Recruiters define the role and evaluation criteria. Aptofy’s AI agent conducts structured interviews, monitors integrity with proctoring, and produces a comprehensive scorecard covering verbal, non-verbal, and written communication.",
      ],
      bullets: [
        "Role-specific AI interviews",
        "Real-time candidate scoring",
        "Cheat-proof proctored environment",
        "Bias-reduced evaluation reports",
        "Faster shortlist decisions",
        "Lower hiring ops overhead",
      ],
    },
    {
      heading: "Key Features of Aptofy’s AI Hiring Platform",
      bullets: [
        "AI Agent Interviewing with customizable questions",
        "Fake candidate detection",
        "100% proctored assessments",
        "Comprehensive skill evaluation reports",
        "Carbon-efficient digital hiring workflows",
        "Scalable hiring for startups and enterprises",
      ],
    },
    {
      heading: "Benefits for Talent Teams",
      paragraphs: [
        "Teams using Aptofy reduce time-to-hire, cut interview coordination costs, and improve consistency across every candidate evaluation — while supporting fairer, more sustainable hiring.",
      ],
      bullets: [
        "Faster hiring cycles",
        "Lower cost-per-hire",
        "More consistent evaluations",
        "Stronger candidate experience",
      ],
    },
    {
      heading: "Ideal Use Cases",
      bullets: [
        "High-volume campus and lateral hiring",
        "Remote and distributed recruitment",
        "Skill-based screening before human rounds",
        "Training institutes and assessment partners",
      ],
    },
  ],
  faqs: [
    {
      question: "What makes Aptofy different from other AI hiring platforms?",
      answer:
        "Aptofy combines patented real-time interview scoring, proctored assessments, bias-reduced evaluation, and carbon-efficient hiring in one platform.",
    },
    {
      question: "Can Aptofy replace human recruiters?",
      answer:
        "No. Aptofy automates interviewing and screening so recruiters can focus on strategic decisions, relationship building, and final hiring calls.",
    },
    {
      question: "Is Aptofy suitable for startups?",
      answer:
        "Yes. Startups use Aptofy to hire faster with lean teams, while enterprises use it to scale consistent evaluations across roles and locations.",
    },
    {
      question: "How quickly can we get started?",
      answer:
        "You can request a demo or start a free trial to set up role-based interviews and begin evaluating candidates quickly.",
    },
  ],
  ctaHeading: "Ready to modernize hiring with AI?",
  ctaText:
    "See how Aptofy’s AI hiring platform can shorten time-to-hire and improve evaluation quality for your team.",
};

export default function AiHiringPlatformPage() {
  return <SeoLandingPage page={page} />;
}
